<template>
  <img
    v-if="isOnboardingRedesign"
    src="@/assets/images/fsa-hsa/hsa-store-logo-purple.png"
  >
  <img
    v-else
    src="@/assets/images/fsa-hsa/hsa-store-logo.png"
  >
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'IconHSAStoreLogo',
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  },
};
</script>
